import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckValid = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 195.8 217.5",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M56.2 216.1c-3.9 0-7.7-1.8-10-5L3.8 155.2c-4.2-5.5-3.1-13.4 2.4-17.6 5.5-4.2 13.4-3.1 17.6 2.4l31.6 41.7L171.1 6.3a12.57 12.57 0 0 1 21 13.8L66.7 210.4c-2.2 3.4-6 5.5-10.1 5.7h-.4",
		fill: "#fff"
	})
});
export default SvgCheckValid;
